<template>
  <v-container class="pa-1">
    <screen use-amount />

    <action-choice
      :from-achat="fromAchat"
      :to-gift="toGift"
      :to-gift-reset="toGiftReset"
      :to-cashless-reset="toCashlessReset"
      :to-b-i="toBI"
      :to-credit="toCredit"
      use-bottom-action
      @title="(t) => { $emit('title', t) }"
    />
  </v-container>
</template>

<script>
import ActionChoice from '../components/ActionChoice'
import { ActionEnum } from '@/modules/Enums'

export default {
  name: 'ActionChoiceView',

  components: {
    ActionChoice
  },

  props: {
    fromAchat: { type: Boolean, default: false },
    action: { type: Number, default: null }
  },

  data () {
    return {
      toGift: this.action === ActionEnum.gift,
      toGiftReset: this.action === ActionEnum.giftReset,
      toCashlessReset: this.action === ActionEnum.cashlessReset,
      toBI: this.action === ActionEnum.badgeInformations,
      toCredit: this.action === ActionEnum.giftCredit
    }
  }
}
</script>
